import { useDispatch, useSelector } from 'react-redux'
import { setHorarioEntrega } from '../../actions/pedidos'
import i18n from '../../lang/idiomas'

/**
 *
 * @param {Object} props
 * @param {boolean} props.pedidoGuardado
 */
const HorarioEntrega = ({ pedidoGuardado }) => {
  const dispatch = useDispatch()
  const pedido_cargando = useSelector(state => state.pedidos.isLoading)
  const pedido = useSelector(state => state.pedidos.pedido)

  /**
   * Handles the change event for the input field.
   *
   * This function will be called whenever the value of the input changes.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event - The event triggered by the input change.
   */
  function handleChange(event) {
    console.log(event.target.value)
    dispatch(setHorarioEntrega(event.target.value))
  }

  return (
    <form className='form-default'>
      <div className='form-group'>
        <label htmlFor='horario_entrega'>{i18n.t('domicilios.horentr')}</label>
        <input
          className='form-control'
          type='text'
          maxLength='100'
          onChange={handleChange}
          name='horario_entrega'
          id='horario_entrega'
          value={pedido?.reservado_alfa_2 || ''}
          placeholder={i18n.t('domicilios.horentrm')}
          disabled={pedidoGuardado || pedido_cargando}
        />
      </div>
    </form>
  )
}

export default HorarioEntrega
